import { Component, Input, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../base.component";
declare var $: any;
@Component({
  selector: "app-student-available-programs",
  templateUrl: "./student-available-programs.component.html",
  styleUrls: ["./student-available-programs.component.css"],
})
export class StudentAvailableProgramsComponent
  extends BaseComponent
  implements OnInit
{
  roleId: any = localStorage.getItem("RoleId");
  isShow: any = localStorage.getItem("UserBaseSidebarMenu");
  roleName: any = localStorage.getItem("RoleName");
  isSubmitStatus: any = localStorage.getItem("is_submit");
  refreshed: boolean = false;
  reload: string = "";
  message: any;
  courseId: any = localStorage.getItem("courseId");
  userData: any;
  @Input() status: boolean;

  constructor(
    CommonService: CommonService,
    private route: Router,
    toastr: ToastrService,
    private active: ActivatedRoute,
    private router: Router
  ) {
    super(CommonService, toastr);

    this.active.queryParams.subscribe((res: any) => {
      this.reload = res.reload;
    });
    // if(this.isSubmitStatus==10){

    // }
  }

  async ngOnInit() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      this.roleId,
      this.CommonService.key
    );
    this.roleId = decryptedValue;
    if (this.reload == "reg") {
      this.refresh();
    }
    this.GetPopupByStatus();
  }
  redirectToReg() {
    return this.route.navigate(["/OneApp/components/application"]);
  }
  refresh() {
    // window.location.reload();
    if (!sessionStorage.getItem("refreshed")) {
      sessionStorage.setItem("refreshed", "true");
      window.location.reload();
    }
  }
  GetPopupByStatus() {
    this.CommonService.postCall("Registration/GetAlertByStatus", {
      USER_ID: this.userId,
      COURSEID: +localStorage.getItem("courseId"),
    }).subscribe((res: any) => {
      this.message = res || [];
      if (
        (this.courseId == "0" ||
          (this.message?.length > 0 && this.message[0]?.IS_SUBMIT == 0)) &&
        !this.status
      ) {
        $("#alertPopup").modal("show");
      } else if (this.message.length > 0 && this.message[0].IS_SUBMIT == 3) {
        this.getAudioPath();
      }
    });
  }
  getAudioPath() {
    this.activeSpinner();
    this.CommonService.postCall("Registration/GetAudioPath", {
      USERID: this.userId,
      COURSE_ID: this.courseId,
    }).subscribe(
      (res: any) => {
        this.userData = res?.result;
        $("#alertPopup").modal("show");
        this.deactivateSpinner();
      },
      (err: any) => {
        this.deactivateSpinner();
      }
    );
  }
}
